import { ThemeEvents } from '@theme/events';

const STORAGE_KEY = 'freeShippingProgress:last';

function prefersReducedMotion() {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
}

function getPrevProgress() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  const num = raw === null ? null : Number(raw);
  return Number.isFinite(num) ? num : null;
}

function setPrevProgress(value) {
  sessionStorage.setItem(STORAGE_KEY, String(value));
}

function animateBanner(banner) {
  const fill = banner.querySelector('.free-shipping__bar-fill');
  if (!fill) return;

  const next = Math.max(0, Math.min(100, Number(banner.dataset.progress || 0)));
  const reduced = prefersReducedMotion();

  // Update aria now (even if reduced motion)
  const bar = banner.querySelector('.free-shipping__bar');
  if (bar) bar.setAttribute('aria-valuenow', String(next));

  if (reduced) {
    fill.style.transition = 'none';
    fill.style.width = `${next}%`;
    setPrevProgress(next);
    return;
  }

  const prev = getPrevProgress();
  const start = prev === null ? 0 : Math.max(0, Math.min(100, prev));

  // Start at previous value without transition
  fill.style.transition = 'none';
  fill.style.width = `${start}%`;

  // Next frame: animate to new value
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      fill.style.transition = 'width 350ms ease';
      fill.style.width = `${next}%`;
      setPrevProgress(next);
    });
  });
}

function animateAll() {
  document.querySelectorAll('[data-free-shipping-progress]').forEach(animateBanner);
}

// Initial run (e.g. first time drawer opens)
animateAll();

// Re-run after cart updates (Savor event)
document.addEventListener(ThemeEvents.cartUpdate, () => {
  // Give the theme a tick to swap updated section HTML into the DOM
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      animateAll();
    });
  });
});
